import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=e124dc7e&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=e124dc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e124dc7e",
  null
  
)

export default component.exports